import { Location } from 'react-router-dom'

/**
 * @returns function that handle get query params
 */
export const useGetQueryParams = (location: Location) =>
  new URLSearchParams(location.search)
